/**
 * Art eines Kontakts — Kunde, Lieferant, Partner, Sonstige.
 *
 * 🔴 ANLASS (#50, gemeldet 26.08.2026): Beim Anlegen aus einer Mail wurde gar
 * nicht danach gefragt, und nachtraeglich liess es sich auch nicht aendern.
 *
 * HERO fuehrt das am Typ `Customer` als `category` (Enum `CustomerCategoryEnum`
 * mit den Werten supplier, customer, partner, other, contact). Die deutsche
 * Beschriftung liefert HERO in `category_name` gleich mit — beim ANZEIGEN also
 * `category_name` bevorzugen und diese Tabelle nur als Rueckfall nehmen.
 *
 * `contact` (Ansprechpartner) steht bewusst nicht zur Auswahl: den vergibt HERO
 * selbst, wenn ein Kontakt unter einem Kunden haengt (Ansprechpartner-Dialog).
 *
 * Spiegel von `KONTAKT_ARTEN` in `core/models.py` — beide Seiten aendern.
 */
export const KONTAKT_ARTEN: { wert: string; label: string }[] = [
  { wert: "customer", label: "Kunde" },
  { wert: "supplier", label: "Lieferant" },
  { wert: "partner", label: "Partner" },
  { wert: "other", label: "Sonstige" },
]

const LABELS: Record<string, string> = {
  ...Object.fromEntries(KONTAKT_ARTEN.map((a) => [a.wert, a.label])),
  contact: "Ansprechpartner",
}

/** Beschriftung einer Art. HEROs eigene `category_name` schlaegt die Tabelle. */
export function kontaktArtLabel(
  category?: string | null,
  categoryName?: string | null,
): string {
  const eigen = (categoryName || "").trim()
  if (eigen) return eigen
  return LABELS[(category || "").trim().toLowerCase()] || ""
}

/**
 * Welche Arten HERO fuer diesen Kontakt noch zulaesst.
 *
 * 🔴 HERO friert die Art nach dem Anlegen ein. Am 27.08.2026 gegen test_tenant
 * als Matrix durchprobiert — alle 16 Kombinationen:
 *
 *   von         customer  supplier   partner     other
 *   customer        ok       NEIN      NEIN      NEIN
 *   supplier      NEIN         ok      NEIN      NEIN
 *   partner       NEIN       NEIN        ok      NEIN
 *   other           ok       NEIN      NEIN      NEIN
 *
 * Erlaubt ist also nur „Sonstige wird Kunde". Alles andere lehnt HERO mit
 * `invalid category change` ab — und weil dabei die GANZE Mutation scheitert,
 * gingen auch Name und Adresse nicht mit durch.
 *
 * Deshalb bietet der Dialog gar nicht erst an, was nicht geht. Marlene hatte
 * mit „iwie kann man das glaub nachtraeglich nicht aendern" recht (#50) — es
 * fehlte nicht nur das Feld, HERO laesst es schlicht nicht zu.
 *
 * Ist die Art unbekannt (Kontakt noch nie gesynct), bleibt alles waehlbar: dann
 * entscheidet HERO, und der Fehler kaeme im Klartext zurueck.
 */
export function erlaubteArtWechsel(aktuell?: string | null): string[] {
  const ist = (aktuell || "").trim().toLowerCase()
  if (!ist) return KONTAKT_ARTEN.map((a) => a.wert)
  if (ist === "other") return ["other", "customer"]
  return [ist]
}

/** Laesst HERO die Art dieses Kontakts ueberhaupt noch aendern? */
export function artIstAenderbar(aktuell?: string | null): boolean {
  return erlaubteArtWechsel(aktuell).length > 1
}
